const question2 = {
    'question': 'Komu jest zalecana terapia EMDR?',
    'answer': 'Terapia EMDR jest zalecana osobom, które doświadczyły traumatycznych wydarzeń, takich jak: wypadek, katastrofa naturalna, akt przemocy, wojna, napaść seksualna. Terapia EMDR może być również pomocna w przypadku innych zaburzeń związanych z traumą, takich jak: zespół stresu pourazowego, zaburzenia obsesyjno-kompulsywne, zaburzenia dysocjacyjne.'
}

export default question2;